import React from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";
import dish1 from "../../images/food/img-1.png";
import dish2 from "../../images/food/img-2.png";
import dish3 from "../../images/food/img-3.png";
import dish4 from "../../images/food/img-4.png";
import dish5 from "../../images/food/img-5.png";
import dish6 from "../../images/food/img-6.png";
import { motion } from "framer-motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const HeroSection2 = () => {
  return (
    <motion.section initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }} className="hero-section-2 position-relative overflow-hidden " id="home">
      <div className="half-rounded d-xxl-block d-none"></div>
      <Container className="position-relative z-2">
        <Row className="align-items-center justify-content-center">
          <Col xxl={6} md={9} className="mb-5 mb-lg-0">
            <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} className="hero-section-main-content text-center text-xxl-start">
              <span className="badge bg-danger bg-opacity-10 text-danger mb-3 px-3 py-2 rounded-pill">
                <i className="ri-leaf-line me-2" /> 100% Organic Ingredients
              </span>
              <motion.h1 initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} className="hero-title display-3 fw-bold mb-4">Savor the <span className="text-danger">Authentic</span> Taste of Tradition </motion.h1>
              <motion.p initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} className="lead text-muted mb-4">Experience culinary excellence with our handcrafted dishes, prepared with love and the finest ingredients for an unforgettable dining experience.</motion.p>
              <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-xxl-start">
                <Button variant="danger" size="lg">Order Now</Button>
                <Button variant="dark" size="lg">Reserve Table</Button>
              </div>

              <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} className="d-flex flex-wrap gap-4 mt-5 text-center text-xxl-start">
                {["1000+ Happy Customers", "50+ Signature Dishes", "Award Winning Chef"].map((item, index) => (
                  <div key={index} className="d-flex align-items-center">
                    <div className="bg-danger bg-opacity-10 rounded-circle avatar avatar-sm me-2">
                      <span className="text-danger fw-bold">{index + 1}</span>
                    </div>
                    <span className="text-muted">{item}</span>
                  </div>
                ))}
              </motion.div>
            </motion.div>
          </Col>

          <Col xxl={6} className="position-relative d-xxl-block d-none">
              <Swiper className="hero-2-food-slider"
                direction={"vertical"}
                slidesPerView={3}
                spaceBetween={20}
                centeredSlides={true}
                loop={true}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                  reverseDirection: true,
                }}
                pagination={{
                  clickable: true,
                }}
                modules={[Autoplay]}
              >
                <SwiperSlide className="hero-2-slider-img"><Image src={dish1} /></SwiperSlide>
                <SwiperSlide className="hero-2-slider-img"><Image src={dish2} /></SwiperSlide>
                <SwiperSlide className="hero-2-slider-img"><Image src={dish3} /></SwiperSlide>
                <SwiperSlide className="hero-2-slider-img"><Image src={dish4} /></SwiperSlide>
                <SwiperSlide className="hero-2-slider-img"><Image src={dish5} /></SwiperSlide>
                <SwiperSlide className="hero-2-slider-img"><Image src={dish6} /></SwiperSlide>
              </Swiper>
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
};

export default HeroSection2;
